import { render } from "./AnalyticsNotesTemplate.vue?vue&type=template&id=58f452c4&scoped=true&ts=true"
import script from "./AnalyticsNotesTemplate.vue?vue&type=script&lang=ts"
export * from "./AnalyticsNotesTemplate.vue?vue&type=script&lang=ts"

import "./AnalyticsNotesTemplate.vue?vue&type=style&index=0&id=58f452c4&scoped=true&lang=scss"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58f452c4"]])

export default __exports__